import axios, { AxiosInstance } from "axios";

export const IEQ_GPT_BASE_URL = `https://qa-kb-llm.ieqmax.io`;

export const ieqGptApi = (): AxiosInstance => {
    const allLocalStorageData = { ...localStorage };
    Object.keys(allLocalStorageData).some((x: any) => {
        if (x.includes("accessToken")) {
            allLocalStorageData["accessToken"] = allLocalStorageData[x];
        }
    });
    const headers = {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${allLocalStorageData?.accessToken}`,
    };
    return axios.create({
        baseURL: IEQ_GPT_BASE_URL,
        withCredentials: false,
        headers,
    });
};

export const ROLES = {
    admin: 'admin',
    tenantAdmin: 'tenantAdmin',
    user: 'user'
}

export const LEVEL_NAMES = {
    level_1: { name: "Tenant", pluralName: "Tenants", value: "l1" },
    level_2: { name: "Facility", pluralName: "Facilities", value: "l2" }
}
